module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921091151_T.3f9c6606.jpg";